import React, { useState, useEffect } from 'react';
import './KrishnaVatikaModal.css';

const amenities = [
  { icon: '🏰', text: 'Fully Fenced Boundaries' },
  { icon: '💧', text: 'Water Submersible' },
  { icon: '🚗', text: 'Dedicated Car Parking' },
  { icon: '🌿', text: 'Majestic Entrance & Landscaping' },
  { icon: '🔒', text: '24/7 Security & CCTV' },
  { icon: '🌳', text: 'Lush Green Spaces' },
  { icon: '⚡', text: 'Power Backup' },
  { icon: '🏊', text: 'Club House' },
];

const floorPlans = [
  {
    option: 'Option 1',
    size: '2550 sq.ft',
    color: '#7B2D8B',
    features: ['4 Bedrooms', '4 Toilets', 'Kitchen', 'Family Lounge', 'Drawing/Dining Area', 'Store/Pooja Room', 'Verandah', 'Terrace Garden'],
  },
  {
    option: 'Option 2',
    size: '2310 sq.ft',
    color: '#2D7B4F',
    features: ['4 Bedrooms', '4 Toilets', 'Kitchen', 'Family Lounge', 'Drawing/Dining Area', 'Store/Pooja Room', 'Verandah', 'Terrace Garden'],
  },
  {
    option: 'Option 3',
    size: '2100 sq.ft',
    color: '#1B6EF3',
    features: ['4 Bedrooms', '4 Toilets', 'Kitchen', 'Family Lounge', 'Drawing/Dining Area', 'Store/Pooja Room', 'Verandah', 'Terrace Garden'],
  },
];

const locationPoints = [
  { time: '5 min', place: 'Crossing Republic, NH-24' },
  { time: '5 min', place: 'Gaur City Mall' },
  { time: '5 min', place: 'ABES College, NH-24' },
  { time: '10 min', place: 'Sector-52, Noida Metro Station' },
  { time: '10 min', place: 'Ghaziabad Railway Station' },
  { time: '15 min', place: 'Noida, Sector-18' },
  { time: '20 min', place: 'Kalindi Kunj' },
];

const specifications = [
  { title: 'Flooring', icon: '🪵', desc: 'Granite Flooring on Parking, Vitrified Tiles (Somany or Equivalent), Anti-Static Tiles for Bathroom & Balcony.' },
  { title: 'Ceiling', icon: '🏠', desc: 'POP in Rooms / Living-Dining Room / Kitchen. Pop/Gypsum Ceiling in Bathroom.' },
  { title: 'Sanitary & Faucets', icon: '🚿', desc: 'European WC and Basin (Hindware/Glint Sanitary). Faucets & Fixtures (Hindware or Equivalent).' },
  { title: 'Kitchen', icon: '🍳', desc: 'High Quality Granite on Slab. SS Double Bowl Sink.' },
  { title: 'Doors & Windows', icon: '🚪', desc: 'Strong Fine Wood Designer Entrance Door. UPVC Window Frames, High Quality Glass (Saint-Gobain/Modi/AIS).' },
  { title: 'Paint', icon: '🎨', desc: 'Asian/Berger Weather Shield External Paint. Emulsion Paint for Internal Walls.' },
  { title: 'Electricals', icon: '⚡', desc: 'Polycab/Havells/Finolex wires. Legrand/Havells/Anchor switches.' },
  { title: 'Railing', icon: '🔩', desc: 'Powder Coated MS Railings for Stairs & Balconies.' },
];

const tabs = ['Overview', 'Amenities', 'Floor Plans', 'Location', 'Specifications', 'Investment'];

export default function KrishnaVatikaModal({ onClose }) {
  const [activeTab, setActiveTab] = useState('Overview');
  const [activePlan, setActivePlan] = useState(0);

  // Lock body scroll
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  // Close on ESC
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div className="kv-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="kv-modal">

        {/* ── HERO BANNER ── */}
        <div className="kv-hero">
          <img src="/image/krishna-vatika.webp" alt="Krishna Vatika" className="kv-hero-img" />
          <div className="kv-hero-overlay" />
          <button className="kv-close" onClick={onClose} aria-label="Close">
            <i className="fa fa-times" />
          </button>
          <div className="kv-hero-content">
            <div className="kv-badge">Paradise Group Presents</div>
            <h1>Krishna Vatika</h1>
            <p className="kv-tagline">4BHK Premium Villas · Sector 16-B, Greater Noida (West)</p>
            <div className="kv-hero-tags">
              <span><i className="fa fa-check-circle" /> RERA Approved</span>
              <span><i className="fa fa-map-marker-alt" /> Greater Noida West</span>
              <span><i className="fa fa-home" /> 4BHK Villas</span>
              <span><i className="fa fa-rupee-sign" /> Starting ₹57 Lac*</span>
            </div>
          </div>
        </div>

        {/* ── TABS ── */}
        <div className="kv-tabs">
          {tabs.map(tab => (
            <button
              key={tab}
              className={`kv-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* ── CONTENT ── */}
        <div className="kv-body">

          {/* OVERVIEW */}
          {activeTab === 'Overview' && (
            <div className="kv-section">
              <div className="kv-overview-grid">
                <div className="kv-overview-text">
                  <h2>Peace of Mind is a State of Mind</h2>
                  <p>
                    <strong>Krishna Vatika Villas</strong> are in close proximity to several gated residential
                    communities. Many educational institutions and shopping malls are within the vicinity
                    of the residential complex.
                  </p>
                  <p>
                    Located in one of the most promising locations of Greater Noida (West), the development
                    in nearby areas makes it worth living. It offers the best in comfort and quality of living
                    with an attractive price bracket.
                  </p>
                  <p>
                    Krishna Vatika is a <strong>low-density project</strong> spread over lush green spaces.
                    The location offers coherent residential units in a pocket-friendly range.
                  </p>
                  <div className="kv-highlights">
                    <div className="kv-highlight-item">
                      <span className="kv-hl-num">59+</span>
                      <span className="kv-hl-label">Premium Villas</span>
                    </div>
                    <div className="kv-highlight-item">
                      <span className="kv-hl-num">4BHK</span>
                      <span className="kv-hl-label">Configuration</span>
                    </div>
                    <div className="kv-highlight-item">
                      <span className="kv-hl-num">22ft</span>
                      <span className="kv-hl-label">Wide Roads</span>
                    </div>
                    <div className="kv-highlight-item">
                      <span className="kv-hl-num">2100+</span>
                      <span className="kv-hl-label">Sq.ft Area</span>
                    </div>
                  </div>
                </div>
                <div className="kv-overview-img">
                  <img src="/image/krishna-vatika.webp" alt="Krishna Vatika Villa" />
                  <div className="kv-price-tag">
                    <span>Starting From</span>
                    <strong>₹57 Lac*</strong>
                  </div>
                </div>
              </div>

              {/* Mindful planning */}
              <div className="kv-comfort-section">
                <h3><i className="fa fa-heart" /> All Comforts Within Reach</h3>
                <p>
                  Along with high-end villas and row houses, the township is in close vicinity to social
                  infrastructure like schools, nursing homes, clinics, cafés, retail and commercial zones.
                  Every member of the family has amenities at their doorstep.
                </p>
              </div>
            </div>
          )}

          {/* AMENITIES */}
          {activeTab === 'Amenities' && (
            <div className="kv-section">
              <h2>Mindful Planning for Every Member of the Family</h2>
              <p className="kv-section-sub">World-class amenities designed for a complete lifestyle experience.</p>
              <div className="kv-amenities-grid">
                {amenities.map((a, i) => (
                  <div className="kv-amenity-card" key={i}>
                    <div className="kv-amenity-icon">{a.icon}</div>
                    <span>{a.text}</span>
                  </div>
                ))}
              </div>

              <div className="kv-quality-brands">
                <h3>Quality Products Used</h3>
                <div className="kv-brands">
                  {['Hindware', 'Somany', 'Asian Paints', 'Havells', 'UltraTech', 'Crompton', 'Polycab', 'Saint-Gobain'].map(b => (
                    <div className="kv-brand-chip" key={b}>{b}</div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* FLOOR PLANS */}
          {activeTab === 'Floor Plans' && (
            <div className="kv-section">
              <h2>Villa Floor Plans</h2>
              <p className="kv-section-sub">Choose from 3 premium floor plan options</p>

              <div className="kv-plan-tabs">
                {floorPlans.map((plan, i) => (
                  <button
                    key={i}
                    className={`kv-plan-tab ${activePlan === i ? 'active' : ''}`}
                    style={activePlan === i ? { background: plan.color, borderColor: plan.color } : {}}
                    onClick={() => setActivePlan(i)}
                  >
                    {plan.option} · {plan.size}
                  </button>
                ))}
              </div>

              <div className="kv-plan-content">
                <div className="kv-plan-info" style={{ borderTop: `4px solid ${floorPlans[activePlan].color}` }}>
                  <div className="kv-plan-header">
                    <h3>4BHK Villa – {floorPlans[activePlan].size}</h3>
                    <span className="kv-plan-badge" style={{ background: floorPlans[activePlan].color }}>
                      {floorPlans[activePlan].option}
                    </span>
                  </div>
                  <div className="kv-plan-features">
                    {floorPlans[activePlan].features.map((f, i) => (
                      <div className="kv-plan-feature" key={i}>
                        <i className="fa fa-check" style={{ color: floorPlans[activePlan].color }} />
                        <span>{f}</span>
                      </div>
                    ))}
                  </div>
                  <div className="kv-plan-floors">
                    <div className="kv-floor-chip">Ground Floor</div>
                    <div className="kv-floor-chip">First Floor</div>
                    <div className="kv-floor-chip">Terrace Floor</div>
                  </div>
                  <button className="kv-enquire-btn" style={{ background: floorPlans[activePlan].color }}>
                    <i className="fa fa-phone" /> Enquire About This Plan
                  </button>
                </div>

                <div className="kv-plan-visual">
                  <div className="kv-floor-diagram">
                    <div className="kv-floor-label">Ground Floor Plan</div>
                    <div className="kv-floor-rooms">
                      <div className="kv-room" style={{ background: '#FFF3E0' }}>Drawing/Dining<br /><small>11'0" × 22'0"</small></div>
                      <div className="kv-room" style={{ background: '#E8F5E9' }}>Bedroom 1<br /><small>13'0" × 11'0"</small></div>
                      <div className="kv-room" style={{ background: '#E3F2FD' }}>Kitchen<br /><small>7'0" × 11'0"</small></div>
                      <div className="kv-room" style={{ background: '#FCE4EC' }}>Toilet<br /><small>8'6" × 5'6"</small></div>
                      <div className="kv-room portico" style={{ background: '#F3E5F5' }}>Portico / Parking</div>
                    </div>
                    <div className="kv-floor-label" style={{ marginTop: 16 }}>First Floor Plan</div>
                    <div className="kv-floor-rooms">
                      <div className="kv-room" style={{ background: '#E8F5E9' }}>Master Bed<br /><small>20'0" × 12'0"</small></div>
                      <div className="kv-room" style={{ background: '#E3F2FD' }}>Bedroom 3<br /><small>20'0" × 14'0"</small></div>
                      <div className="kv-room" style={{ background: '#FCE4EC' }}>2 Toilets<br /><small>8'6" × 5'6"</small></div>
                      <div className="kv-room" style={{ background: '#FFF9C4' }}>Balcony<br /><small>20'0" × 5'0"</small></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* LOCATION */}
          {activeTab === 'Location' && (
            <div className="kv-section">
              <h2>Well Connected Location</h2>
              <p className="kv-section-sub">Sector 16-B, Greater Noida (West) – strategically placed near all essentials</p>

              <div className="kv-location-grid">
                <div className="kv-location-list">
                  <h3><i className="fa fa-map-marker-alt" /> Distance Advantage</h3>
                  {locationPoints.map((l, i) => (
                    <div className="kv-loc-item" key={i}>
                      <div className="kv-loc-time">{l.time}</div>
                      <div className="kv-loc-place">{l.place}</div>
                    </div>
                  ))}
                </div>

                <div className="kv-nearby">
                  <div className="kv-nearby-group">
                    <h3><i className="fa fa-graduation-cap" /> Schools Nearby</h3>
                    <ul>
                      <li>Wisdom Tree School</li>
                      <li>SKS World School</li>
                      <li>BLS World School</li>
                    </ul>
                  </div>
                  <div className="kv-nearby-group">
                    <h3><i className="fa fa-shopping-bag" /> Shopping & Malls</h3>
                    <ul>
                      <li>Gaur City Mall</li>
                      <li>Galaxy Diamond Plaza</li>
                      <li>PKS Town Central</li>
                      <li>DLF Mall of India</li>
                    </ul>
                  </div>
                  <div className="kv-nearby-group">
                    <h3><i className="fa fa-hospital" /> Hospitals</h3>
                    <ul>
                      <li>Yashoda Hospital</li>
                      <li>Metro Hospital</li>
                      <li>Yatharth Hospital</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="kv-map-embed">
                <iframe
                  title="Krishna Vatika Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.5!2d77.4538!3d28.6354!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sGreater%20Noida%20West!5e0!3m2!1sen!2sin!4v1699999999999"
                  width="100%" height="220"
                  style={{ border: 0, borderRadius: 12 }}
                  allowFullScreen="" loading="lazy"
                />
              </div>
            </div>
          )}

          {/* SPECIFICATIONS */}
          {activeTab === 'Specifications' && (
            <div className="kv-section">
              <h2>Space With Unlimited Freedom</h2>
              <p className="kv-section-sub">Premium quality materials & finishes throughout</p>
              <div className="kv-specs-grid">
                {specifications.map((s, i) => (
                  <div className="kv-spec-card" key={i}>
                    <div className="kv-spec-icon">{s.icon}</div>
                    <div>
                      <h4>{s.title}</h4>
                      <p>{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* INVESTMENT */}
          {activeTab === 'Investment' && (
            <div className="kv-section">
              <div className="kv-invest-hero">
                <div className="kv-invest-text">
                  <span className="kv-invest-label">Golden Opportunity</span>
                  <h2>Investment Opportunity</h2>
                  <p>
                    Investing in property at <strong>Krishna Vatika</strong> is a smart and secure investment
                    decision. With its strategic location and excellent infrastructure, the property value
                    of this area is on the rise.
                  </p>
                  <p>
                    The demand for residential and commercial properties in this area is increasing, and
                    it is expected to grow exponentially in the coming years.
                  </p>
                  <p>
                    Investing in Krishna Vatika can provide you with a <strong>reliable and steady source
                    of passive income</strong>, as well as potential capital appreciation.
                  </p>
                  <div className="kv-invest-points">
                    <div className="kv-invest-point"><i className="fa fa-trending-up" />📈 High ROI Expected</div>
                    <div className="kv-invest-point"><i className="fa fa-check" />✅ Growing Demand in Area</div>
                    <div className="kv-invest-point"><i className="fa fa-check" />✅ Capital Appreciation</div>
                    <div className="kv-invest-point"><i className="fa fa-check" />✅ Passive Income Potential</div>
                    <div className="kv-invest-point"><i className="fa fa-check" />✅ Pocket-Friendly Pricing</div>
                  </div>
                </div>
                <div className="kv-invest-contact">
                  <h3>Get In Touch</h3>
                  <div className="kv-contact-item">
                    <i className="fa fa-building" />
                    <div>
                      <strong>Corp. Office: Paradise Group</strong>
                      <p>Sec 16, Behind SKS World School,<br />Chipyana Bujurg, Greater Noida West,<br />Greater Noida – 201009</p>
                    </div>
                  </div>
                  <div className="kv-contact-item">
                    <i className="fa fa-envelope" />
                    <div>
                      <strong>Email</strong>
                      <p>info@paradisegroupncr.com</p>
                    </div>
                  </div>
                  <div className="kv-contact-item">
                    <i className="fa fa-globe" />
                    <div>
                      <strong>Website</strong>
                      <p>www.paradisegroupncr.com</p>
                    </div>
                  </div>
                  <button className="kv-enquire-btn purple">
                    <i className="fa fa-phone" /> Book a Site Visit
                  </button>
                </div>
              </div>

              <div className="kv-disclaimer">
                <strong>Disclaimer:</strong> This brochure, floor plans and any marketing material does not form
                part of any contract. All layouts, plans, specifications, dimensions and designs are indicative
                only. Subject to change as may be decided by the company or competent authority. *T&C Apply.
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
